import Image from "next/image";
import notion from "../../assets/brands/notion.svg";
import Flashcard from "../shared/Flashcard";
import NotionImage from "../../assets/images/notion-illustration.png";

const NotionCard = () => {
  return (
    <div className="bg-white border border-black border-dashed rounded-[28px] w-[365px] h-[305px] relative overflow-hidden">
      <div className="w-[80%] flex items-center gap-3.5 pl-6 pt-[18px]">
        <Image src={notion} alt="notion" />
        <div className="text-sm font-semibold max-sm:w-[60%]">
          Turn your Notion notes into study materials in an instant.
        </div>
      </div>
      <div className="absolute top-[60%] left-[25%] rotate-6 transition-transform duration-300 hover:scale-110 hover:rotate-0">
        <Flashcard
          question="What is the capital of France?"
          hint="Paris"
          subject="History"
          color="#DFF2FE"
          subjectColor="#F0F9FF"
        />
      </div>
      <div className="absolute top-[45%] left-[10%] -rotate-[-0.5deg] transition-transform duration-300 hover:scale-110 hover:rotate-0">
        <Flashcard
          question="What type of macromolecule are enzymes?"
          hint="Made of amino acids."
          subject="History"
          color="#DAB2FF"
          subjectColor="#F0F9FF"
        />
      </div>
      <div className="absolute top-[60%] left-[-20%] rotate-[-6deg] transition-transform duration-300 hover:scale-110 hover:rotate-0">
        <Flashcard
          question="What's the formula for the sum of an arithmetic series?"
          hint="Involves the number of terms, first, and last term."
          subject="Math"
          color="#7BF1A8"
          subjectColor="#F0F9FF"
        />
      </div>
    </div>
  );
};

const NotionFeatureCard = () => {
  return (
    <div className="bg-[#F0F9FF] rounded-[32px] w-[300px] h-[500px] sm:w-[330px] sm:h-[550px] md:w-[360px] md:h-[600px] py-6 flex flex-col relative items-center border border-black border-dashed overflow-hidden">
      <h2 className="text-black text-[24px] sm:text-[26px] md:text-[28px] font-bold text-center mb-6 sm:mb-8">
        Notion
      </h2>
      <div className="absolute top-1/2 left-[70%] sm:left-[60%] -translate-x-1/2 -translate-y-1/2">
        <NotionCard />
      </div>
      <div className="absolute top-[78%] left-[60%] w-full h-full">
        <Image src={NotionImage} alt="notion-illustration" />
      </div>
    </div>
  );
};

export default NotionFeatureCard;
